import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { autocomplete } from './components/autocomplete';
import { button } from './components/button';
import { datepicker } from './components/datepicker';
import { inputtext } from './components/inputtext';
import { multiselect } from './components/multiselect';
import { select } from './components/select';
import { textarea } from './components/textarea';
import { selectbutton } from './components/selectbutton';

export const CustomPreset = definePreset(Aura, {
  semantic: {
    // https://uicolors.app/generate/00325a
    primary: {
      '50': '#f0f5fa',
      '100': '#cddbe9',
      '200': '#8ba8ca',
      '300': '#547da6',
      '400': '#2c5882',
      '500': '#00325a',
      '600': '#002b4d',
      '700': '#002440',
      '800': '#001d34',
      '900': '#001628',
      '950': '#000e1c',
      default: '#00325a',
    },
    // https://uicolors.app/generate/f5a500
    accent: {
      '50': '#fffdea',
      '100': '#fff7c5',
      '200': '#ffef85',
      '300': '#ffdf46',
      '400': '#ffcd1b',
      '500': '#f5a500',
      '600': '#e28200',
      '700': '#bb5a02',
      '800': '#984608',
      '900': '#7c390b',
      '950': '#481c00',
      default: '#f5a500',
    },
    danger: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#e02424',
      600: '#c81e1e',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
      950: '#450a0a',
      default: '#e02424',
    },
    colorScheme: {
      light: {
        accent: {
          color: '{accent.500}',
          contrastColor: '#ffffff',
          hoverColor: '{accent.600}',
          activeColor: '{accent.700}',
        },
        danger: {
          color: '{danger.600}',
          contrastColor: '#ffffff',
          hoverColor: '{danger.800}',
          activeColor: '{danger.900}',
        },
      },
    },
  },
  components: {
    autocomplete,
    button,
    datepicker,
    inputtext,
    multiselect,
    select,
    selectbutton,
    textarea,
  },
  css: ({ dt }) => {
    const dynamicDialogClasses = `
      .p-dialog-content {
        &:has(.footer-bar) {
          padding-bottom: 0px !important;
        }
      }
    `;

    return `${dynamicDialogClasses}`;
  },
});
